"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.buildSubAccounts = exports.decodeTokenCurrencyId = exports.decodeTokenAssetId = exports.getTokenAssetId = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var operation_1 = require("../../operation");
var logic_1 = require("./logic");
var typhonjs_1 = require("@stricahq/typhonjs");
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var account_1 = require("../../account");
var lodash_1 = require("lodash");
var jsHelpers_1 = require("../../bridge/jsHelpers");
var getTokenAssetId = function (_a) {
    var policyId = _a.policyId, assetName = _a.assetName;
    return "".concat(policyId).concat(assetName);
};
exports.getTokenAssetId = getTokenAssetId;
var decodeTokenAssetId = function (id) {
    var policyId = id.slice(0, 56);
    var assetName = id.slice(56);
    return { policyId: policyId, assetName: assetName };
};
exports.decodeTokenAssetId = decodeTokenAssetId;
var encodeTokenCurrencyId = function (parentCurrency, assetId) { return "".concat(parentCurrency.id, "/native/").concat(assetId); };
var decodeTokenCurrencyId = function (id) {
    var _a = __read(id.split("/"), 3), parentCurrencyId = _a[0], type = _a[1], assetId = _a[2];
    return {
        parentCurrencyId: parentCurrencyId,
        type: type,
        assetId: assetId
    };
};
exports.decodeTokenCurrencyId = decodeTokenCurrencyId;
/**
 * @returns operations of tokens that are defined in ledgerjs cryptoassets
 */
var mapTxToTokenAccountOperation = function (_a) {
    var parentAccountId = _a.parentAccountId, parentCurrency = _a.parentCurrency, newTransactions = _a.newTransactions, accountCredentialsMap = _a.accountCredentialsMap;
    var operations = [];
    newTransactions.forEach(function (tx) {
        var accountChange = (0, logic_1.getAccountChange)(tx, accountCredentialsMap);
        accountChange.tokens.forEach(function (token) {
            var assetId = (0, exports.getTokenAssetId)({
                policyId: token.policyId,
                assetName: token.assetName
            });
            var tokenCurrencyId = encodeTokenCurrencyId(parentCurrency, assetId);
            var tokenCurrency = (0, cryptoassets_1.findTokenById)(tokenCurrencyId);
            // skip the unsupported tokens by ledger-live
            if (tokenCurrency === null || tokenCurrency === undefined) {
                return;
            }
            var tokenAccountId = (0, account_1.encodeTokenAccountId)(parentAccountId, tokenCurrency);
            var tokenOperationType = token.amount.lt(0) ? "OUT" : "IN";
            var memo = (0, logic_1.getMemoFromTx)(tx);
            var extra = {};
            if (memo) {
                extra["memo"] = memo;
            }
            var operation = {
                accountId: tokenAccountId,
                id: (0, operation_1.encodeOperationId)(tokenAccountId, tx.hash, tokenOperationType),
                hash: tx.hash,
                type: tokenOperationType,
                fee: new bignumber_js_1["default"](tx.fees),
                value: token.amount.absoluteValue(),
                senders: tx.inputs.map(function (i) {
                    return (0, logic_1.isHexString)(i.address)
                        ? typhonjs_1.utils.getAddressFromHex(i.address).getBech32()
                        : i.address;
                }),
                recipients: tx.outputs.map(function (o) {
                    return (0, logic_1.isHexString)(o.address)
                        ? typhonjs_1.utils.getAddressFromHex(o.address).getBech32()
                        : o.address;
                }),
                blockHeight: tx.blockHeight,
                date: new Date(tx.timestamp),
                extra: extra,
                blockHash: undefined
            };
            operations.push(operation);
        });
    });
    return operations;
};
function buildSubAccounts(_a) {
    var e_1, _b;
    var _c;
    var initialAccount = _a.initialAccount, parentAccountId = _a.parentAccountId, parentCurrency = _a.parentCurrency, newTransactions = _a.newTransactions, tokens = _a.tokens, accountCredentialsMap = _a.accountCredentialsMap;
    var tokenAccountsById = {};
    if (initialAccount && initialAccount.subAccounts) {
        try {
            for (var _d = __values(initialAccount.subAccounts), _e = _d.next(); !_e.done; _e = _d.next()) {
                var existingAccount = _e.value;
                if (existingAccount.type === "TokenAccount") {
                    tokenAccountsById[existingAccount.id] = existingAccount;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_b = _d["return"])) _b.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    var tokenOperations = mapTxToTokenAccountOperation({
        parentAccountId: parentAccountId,
        parentCurrency: parentCurrency,
        newTransactions: newTransactions,
        accountCredentialsMap: accountCredentialsMap
    });
    var tokenOperationsByAccId = (0, lodash_1.groupBy)(tokenOperations, function (o) { return o.accountId; });
    var tokensBalanceByAssetId = (0, lodash_1.keyBy)(tokens, function (t) { return (0, exports.getTokenAssetId)(t); });
    for (var tokenAccountId in tokenOperationsByAccId) {
        var initialTokenAccount = tokenAccountsById[tokenAccountId];
        var oldOperations = (initialTokenAccount === null || initialTokenAccount === void 0 ? void 0 : initialTokenAccount.operations) || [];
        var newOperations = tokenOperationsByAccId[tokenAccountId] || [];
        var operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
        var tokenCurrency = (0, account_1.decodeTokenAccountId)(tokenAccountId).token;
        if (tokenCurrency) {
            var accountBalance = ((_c = tokensBalanceByAssetId[tokenCurrency.contractAddress]) === null || _c === void 0 ? void 0 : _c.amount) ||
                new bignumber_js_1["default"](0);
            var tokenAccount = {
                type: "TokenAccount",
                id: tokenAccountId,
                parentId: parentAccountId,
                token: tokenCurrency,
                balance: accountBalance,
                spendableBalance: accountBalance,
                creationDate: operations.length > 0
                    ? operations[operations.length - 1].date
                    : new Date(),
                operationsCount: operations.length,
                operations: operations,
                pendingOperations: [],
                starred: false,
                balanceHistoryCache: account_1.emptyHistoryCache,
                swapHistory: []
            };
            tokenAccountsById[tokenAccountId] = tokenAccount;
        }
    }
    return Object.values(tokenAccountsById);
}
exports.buildSubAccounts = buildSubAccounts;
//# sourceMappingURL=buildSubAccounts.js.map